import React, { Component } from 'react';
import { Card } from 'antd';
import PropTypes from 'prop-types'; // ES6

import { convertirTextAMomentUTC, MASCARA_DDMMYYYY, MASCARA_YYYYMMDD } from '../../commons/gestioDates';
import { textQuanNoHiHaDada } from '../../constants';

import LocalitzacioDetallMapa from '../commons/localitzacioDetallMapa';

class ObservacioIntroduccioDadesEstacio extends Component {

    renderObservador(observadors) {
        var observadorList = observadors.map((observador, index) => {
            return <div key={index} className="observacio-dades-estacio-observador-nom">{observador.nom} {observador.cognom1}</div>;
        });

        return (
            <div>
                <div className="observacio-dades-estacio-observador-titol"><span>Observador/s:</span></div>
                {observadorList}
            </div>
        );
    }

    render() {
        const estacio = this.props.estacio;
        const coordenades = estacio.coordenades;

        let dataAlta = convertirTextAMomentUTC(estacio.dataAlta, MASCARA_YYYYMMDD);
        let dataAltaText;
        if (dataAlta) {
            dataAltaText = dataAlta.format(MASCARA_DDMMYYYY);
        }

        return (
            <Card id='dades_estacio' title='Dades estació' className="observacio-introduccio-dades-estacio">
                <div className="observacio-dades-estacio-row" >
                    <div><span>Codi:</span>{estacio.codi}</div>
                </div>

                <div className="observacio-dades-estacio-row-data-alta">
                    <span>Data d'alta:</span>{dataAltaText}
                </div>

                <div className="observacio-dades-estacio-row">
                    <div><span>Comarca:</span>{estacio.comarca || textQuanNoHiHaDada}</div>
                    <div><span>Municipi:</span>{estacio.municipi || textQuanNoHiHaDada}</div>
                </div>

                <div className="observacio-dades-estacio-observador-observadors">
                    {this.renderObservador(estacio.observadors)}
                </div>

                <LocalitzacioDetallMapa coordenades={coordenades} classeCss='localitzacio-detall-mapa' />
            </Card>
        );
    }
}

ObservacioIntroduccioDadesEstacio.propTypes = {
    estacio: PropTypes.object.isRequired
};

export default ObservacioIntroduccioDadesEstacio;



// WEBPACK FOOTER //
// ./src/components/observacio/observacioIntroduccioDadesEstacio.js